import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { CreateIntegrationCredentialPayload } from '@rossum/api-client/integrationCredentials';
import { api } from '../../../../lib/apiClient';
import { credentialKeys } from './queryKeys';

export const useCreateCredential = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateIntegrationCredentialPayload) =>
      api.request(endpoints.integrationCredentials.create(payload)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: credentialKeys.list() });
    },
  });
};
